/* import __COLOCATED_TEMPLATE__ from './list-tabs.hbs'; */
import Component from '@glimmer/component';

export default class PlaylistListTabsComponent extends Component {}
